const controller = "messages";

export default {
  controller,
};
